<template>
  <div>
    <keep-alive>
      <component :is="coms" :cutcoms="cutcoms"></component>
    </keep-alive>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive: 0,
      examInfo: {},
      examRow: {}, // 批阅当前操作试卷
      isread: "",
      PaperMode:'', // 试卷类型状态
    };
  },
  components: {
    CertifiedHosp: () => import("./components/page.vue"),
    TheApproved: () => import("./components/resultsQuery.vue"),
    TheEditor: () => import("./components/HeExamines.vue"),
    ReDoExam: () => import("./components/reDoExam/index.vue"),
    Encryption: () => import("./components/Resultslist.vue"),
    // DecryTable: () => import("./components/encryption/decryTable.vue"),
    // ModifyThe: () => import("../../layout/components/userCenter/index.vue"),
  },
  computed: {
    coms() {
      switch (this.isActive) {
        case 0:
          return "CertifiedHosp";
        case 1:
          return "TheApproved";
        case 2:
          return "TheEditor";
        case 3:
          return "ReDoExam";
            case 4:
          return "Encryption";
      }
      return "ss";
    },
  },
  methods: {
    cutcoms(index) {
       if (index == "0" && this.isActive == "1"){
         // 成绩查询
          this.$children[0].Buriedpoint({
          code: "OnlineTest:Correcting:scoreQuery",
          parent_code: "OnlineTest:Correcting",
        });
       }
      this.isActive = index;
    },
  },
};
</script>
